import React from 'react'
import { dateDisplayFromString, getStudentName } from '../helpers'

const PAGE_ROWS = 40

export default class InstructorStudentsCatalogToPrint extends React.Component {
  getPage = (course, students, index) => (
    <div key={index}>
      <h1 />
      <br />
      <div
        style={{
          textAlign: 'center',
          paddingTop: 10,
          paddingLeft: 10,
          paddingRight: 10,
          marginLeft: 10,
        }}
      >
        <h5>CATALOG</h5>
        <span>cu asistentii medicali participanti la cursul {course.name}</span>
        <table
          border="1"
          style={{
            borderWidth: 'thin',
            borderSpacing: 0,
            borderStyle: 'solid',
            borderColor: 'black',
            borderCollapse: 'collapse',
            width: '90%',
            margin: 20,
          }}
        >
          <thead>
            <tr>
              <th rowSpan="2">Nr.</th>
              <th rowSpan="2">NUME PRENUME</th>
              <th colSpan="1">PREZENTA</th>
              <th rowSpan="2">NOTA</th>
            </tr>
            <tr>
              <th>
                <span>&nbsp;</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {students.map((student, index) => {
              const isEmpty = Object.keys(student).length === 0
              return (
                <tr key={index} style={{ textAlign: 'center' }}>
                  <td key="1">{index + 1}</td>
                  <td key="2">{isEmpty ? '' : getStudentName(student)}</td>
                  <td key="3" />
                  <td key="4">{isEmpty ? '' : student.grade}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <div style={{ textAlign: 'left', marginLeft: 60 }}>
          <div>
            <span>LECTOR,</span>
          </div>
          <div>
            <span>(semnatura)</span>
          </div>
        </div>
      </div>
      <h1 />
    </div>
  )

  render() {
    const { students, course } = this.props

    const maxFill =
      Math.ceil(students.length / PAGE_ROWS) * PAGE_ROWS + PAGE_ROWS
    const totalPages = Math.ceil(students.length / PAGE_ROWS) + 1
    const pagesArray = new Array(totalPages).fill(1)
    console.log({students})
    const studentsFilled = [
      ...students.sort((a, b) => a.lastName.localeCompare(b.lastName)),
      ...new Array(maxFill - students.length).fill({}),
    ]

    if (!course || Object.keys(course).length === 0) return null

    return (
      <div>
        {pagesArray.map((_, index) =>
          this.getPage(
            course,
            studentsFilled.slice(
              index * PAGE_ROWS,
              index * PAGE_ROWS + PAGE_ROWS,
            ),
            index,
          ),
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/InstructorStudentsCatalogToPrint.js